import { RecursoFiltro } from './../../../entity/recurso-filtro.model';
import { Recurso } from './../../../entity/Recurso.model';
import { Component, OnInit, Input } from '@angular/core';
import { BaseStepComponent } from '../../../base';

@Component({
  selector: 'gerenciamanento-curso-exterior-etapa2',
  templateUrl: './etapa2.component.html'
})
export class GerenciamentoCursoExteriorEtapa2Component extends BaseStepComponent {
  @Input() gerenciamentoCursoExterior: any;
  @Input() acao: string;
  @Input() listaResumo: any[];
  @Input() listaRelatores: any[];
  @Input() listaTipoAtividade: any[] = [];
  @Input() listaModalidade: any[] = [];
  @Input() listaAreaTematica: any[] = [];
  @Input() listaPais: any[] = [];
  @Input() listaPntCFC: any[] = [];
  @Input() listaPntCRC: any[] = [];
  @Input() etapaHomologacao = 3;
  @Input() mostrarCodigo: boolean;
  @Input() controladorGerenciamento = true;
  @Input() recurso: Recurso[] = [];
  @Input() id: number;
  @Input() recursoFiltro: RecursoFiltro;
  @Input() decisaoComissaoCrc: any;
  @Input() habilitaCamposPontuacao: boolean;
  @Input() disabledCheckbox: boolean;
  @Input() etapa: number;
  @Input() isHomologacao: boolean;

  init() {
    if (this.listaModalidade.length == 0) {
      this.service.ListarTodos('modalidade').subscribe(data => {
        this.listaModalidade = data;
      });
    }
    if (this.listaAreaTematica.length == 0) {
      this.service.ListarTodos('areaTematica').subscribe(data => {
        this.listaAreaTematica = data;
      });
    }
    if (this.listaPais.length == 0) {
      this.service.ListarTodos('pais').subscribe(data => {
        this.listaPais = data;
      });
    }
    if (this.id !== undefined) {
      this.service.Obter('gerenciamentoCursoExterior/recursoList', this.id).subscribe(item => {
        this.recurso = item;
      });
      this.recursoFiltro.IdModel = this.id;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/gerenciamento-curso-exterior/crud/etapa2/etapa2.component.ts